const colorMap = new Map([
    ['Rust', ["#b7410e", false]],
    ['Multicolor', ["https://i.ibb.co/BVjj74X/classic-color-spectrum-rgb-line-gradient-vector-522680-173-copy.png", true]],
    ['Multi', ["https://i.ibb.co/BVjj74X/classic-color-spectrum-rgb-line-gradient-vector-522680-173-copy.png", true]],
    ['Peach', ["#ffdab9", false]],
    ['Golden', ["#ffd900", false]],
    ['Off-White', ["#f5f5f5", false]],
    ['Cream', ["#fffdd0", false]],
    ['Sky Blue', ["#87CEEB", false]],
    ['Navy Blue', ["#000080", false]],
    ['Light Blue', ["#ADD8E6", false]],
    ['Olive Green', ["#556B2F", false]],
    ['Light Green', ["#90EE90", false]],
    ['Dark Grey', ["#A9A9A9", false]],
    ['Dark Blue', ["#00008B", false]],
    ['Jet Black', ["#000000", false]],
    ['Bright White', ["#FFFFFF", false]],
    ['Light Grey', ["#D3D3D3", false]],
    ['Wine', ["#722F37", false]],
    ['Teal Blue', ["#008080", false]],
  ['Royal Blue', ["#4169E1", false]],
  ['Indigo Blue', ["#4B0082", false]],
  ['Mid Blue', ["#0000CD", false]],
  ['Peacock Blue', ["#006994", false]],
  ['Deep Blue', ["#000080", false]],
  ['Aqua Blue', ["#00FFFF", false]],
  ['Ice Blue', ["#BCE6E6", false]],
  ['Night Blue', ["#191970", false]],
  ['Denim Blue', ["#1560BD", false]],
  ['Turquoise Blue', ["#40E0D0", false]],
  ['Brick Red', ["#B22222", false]],
  ['Light Red', ["#FF6961", false]],
  ['Dark Red', ["#8B0000", false]],
  ['Bright Red', ["#FF0000", false]],
  ['Carrot red', ["#FF4500", false]],
  ['Burn Red', ["#9A3334", false]],
  ['Cardinal Red', ["#C41E3A", false]],
  ['Oxblood Red', ["#800020", false]],
  ['Rio Red', ["#DA2C43", false]],
  ['Rose Red', ["#FF033E", false]],
  ['Rumba Red', ["#C76E70", false]],
  ['Spice Red', ["#A23C3C", false]],
  ['Tango Red', ["#E25822", false]],
  ['Deep Red', ["#8B0000", false]],
  ['Mustard Yellow', ["#FFDB58", false]],
  ['Light Yellow', ["#FFFFE0", false]],
  ['Lemon Yellow', ["#FFF44F", false]],
  ['Mellow Yellow', ["#F8DE7E", false]],
  ['Bright Yellow', ["#FFFF00", false]],
  ['Golden Yellow', ["#FFD700", false]],
  // ['Honey Yellow', ["#E0Cfalse", false]],
  ['Chrome Yellow', ["#FFA700", false]],
  ['Corn Yellow', ["#FBEC5D", false]],
  ['Musturd Yellow', ["#FFDB58", false]],
  ['Pale Yellow', ["#EEE8AA", false]],
  ['Pastel Yellow', ["#FDFD96", false]],
  ['Taffy Yellow', ["#F8DE7E", false]],
  ['Dark Green', ["#006400", false]],
  ['Light Pink', ["#FFB6C1", false]],
  ['Onion Pink', ["#F5B9F5", false]],
  ['Island Pink', ["#FFD1DC", false]],
  ['Lilac Pink', ["#FFC0CB", false]],
  ['Rose Pink', ["#FF66CC", false]],
  ['Coral Pink', ["#FF7F50", false]],
  ['Dusty Pink', ["#D8BFD8", false]],
  ['Send Pink', ["#FF91A4", false]],
  ['Blossom Pink', ["#FFC3A0", false]],
  ['Delicacy Pink', ["#FEC3AC", false]],
  ['Flamingo Pink', ["#FC8EAC", false]],
  ['Pastel Pink', ["#FFD1BB", false]],
  ['Baby Pink', ["#FFC0CB", false]],
  ['Pastel Purple', ["#B39EB5", false]],
  ['Dark Purple', ["#800080", false]],
  ['Beige', ["#F5F5DC", false]],
  ['Light Purple', ["#E6E6FA", false]],
  ['Cloud Cream', ["#FFF8E7", false]],
  ['Custard Cream', ["#FFF0C1", false]],
  ['Dark Cream', ["#EEE8AA", false]],
  ['Dawn Cream', ["#FFFAF0", false]],
  ['Fawn Cream', ["#E5AA70", false]],
  ['Italian Cream', ["#F6ECD8", false]],
  ['Light Orange', ["#FFD68F", false]],
  ['Apricot Orange', ["#FDD5B1", false]],
  ['Bright Orange', ["#FF8C00", false]],
  ['Burnt Orange', ["#FF4500", false]],
  ['Coral Orange', ["#FF7F50", false]],
  ['Golden Orange', ["#FFD700", false]],
  ['Apricot Orange', ["#FBCEB1", false]],
  ['Dark Olive', ["#556B2F", false]],
  ['Olive Brown', ["#806517", false]],
  ['Light Olive', ["#AAB300", false]],
  ['Olive Grey', ["#B5B35C", false]],
  ['Branch Olive', ["#5F6527", false]],
  ['Dark Olive Green', ["#556B2F", false]],
  ['Deep Olive Green', ["#556B2F", false]],
  ['Dusty Olive', ["#8A8662", false]],
  ['Olive Melange', ["#6B6C4A", false]],
  ['Dark Maroon', ["#800000", false]],
  ['Maroon gold', ["#B03060", false]],
  ['Silver Grey', ["#C0C0C0", false]],
  ['Lime Green', ["#00FF00", false]],
  ['State Gray', ["#808080", false]],
  ['Teal Green', ["#008080",false]],
  ['Dusty Teal', ["#4e5d4e",false]],
  ['Teal Black', ["#003838",false]],
  ['Teal Grey', ["#69838d",false]],
  ['Midnight Navy', ["#000080", false]],
    ['Grey Melange', ["#808080", false]],
  ['Charcoal Grey', ["#36454F", false]],
  ['Ercus Melange', ["#B5B5B5", false]],
  ['Air Force Blue', ["#5D8AA8", false]],
  ['Aquamarine Blue', ["#7FFFD4", false]],
  ['Carrot Brown', ["#ED9121", false]],
  ['Colonial Blue', ["#002F6C", false]],
  ['Cornet Blue', ["#6495ED", false]],
  ['Deep Wine', ["#8B0000", false]],
  ['Bottle Green', ["#092E20", false]],
]);

window.onWizzyScriptLoaded = function () {
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_INIT,
    function (data) {
      // console.log("wizzy init", data);
      data.search.configs.pagination.appendInExistingList = true;
      window.wizzyConfig['search']['configs']['pagination']['infiniteScrollOffset'] = {
          desktop: 2000,
          mobile: 1000
      };
      data.filters.configs.keepOpenedInMobileAfterApply = true;
      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_EXECUTED,
    function (data) {
      
      return data;
    }
  );
  
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED,
    function (data) {
      var breadCrumb = document.querySelector('.wizzy-search-results-rendered #MainContent .page-width .breadcrumbs');

      if (breadCrumb) {
        breadCrumb.style.display = 'none';
      }
      
      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_FILTERS_EXECUTED,
    function (data) {

      data.filters.attributeFacetValuesLimit = 50;
      
      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_WRAPPER_RENDER,
    function (data) {
      // console.log("Wiz BEFORE_AUTOCOMPLETE_WRAPPER_RENDER", data);
      
      
      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_RENDER_RESULTS,
    function (data) {
      // console.log("Wiz BEFORE_RENDER_RESULTS", data);
      if (data.api === "search" || data.api === "filter") {
          var facets = data?.response?.payload?.facets;
          facets?.forEach((facet) => {
            if (facet.key === "sizes") {
              let sizes = facet.data;
    
              let newArray = new Array();
              let temp = [
                "XXS",
                "XS",
                "XS/S",
                "S",
                "S/M",
                "M",
                "M/L",
                "L",
                "L/XL",
                "XL",
                "XXL",
                "XXXL",
                "0/3",
                "3/6",
                "6/12",
                "12/18",
                "18/24",
                "2",
                "4",
                "6",
                "8",
                "10",
                "12",
                "14",
                "16",
                "26",
                "28",
                "30",
                "32",
                "34",
                "36",
                "38",
                "40",
                "42",
                "44",
                "060",
                "070",
                "50 cm",
                "55 cm",
                "60 cm",
                "65 cm",
                "70 cm",
                "75 cm",
                "120cm",
                "130 CM",
                "150cm",
                "180cm",
                "58g",
                "66g",
                "83.5g",
                "90g",
                "93g",
                "95g",
                "120g",
                "358g",
                "395g",
                "410g",
                "415g",
                "20m",
                "30m",
                "40m",
                "50m",
                "60m",
                "All Sizes",
                "10+ years",
                "375 ml",
                "620ml",
                "620 ml",
                "750ml",
                "900 ml",
                "950ml",
                "950 ml",
                "975 ml",
                "1100ml",
                "1X",
                "2X",
                "3X",
                "4X",
                "5X",
                "6X",
                "2-3Y",
                "3-4Y",
                "4.5Y",
                "5Y",
                "5-6Y",
                "5.5Y",
                "11-13Y",
                "6 - 7 years",
                "6.5 - 7 years",
                "7 - 8 years",
                "8 - 9 years",
                "9 - 10 years",
                "10 years",
                "EXT",
                "L/G",
                "One Size",
                "OS",
                "Regular",
                "UK-3",
                "UK-3.5",
                "UK-4",
                "UK-4.5",
                "UK-5",
                "UK-5.5",
                "UK-6",
                "UK-6.5",
                "UK-7",
                "UK-7.5",
                "UK-8",
                "UK-8.5",
                "UK-9",
                "UK-9.5",
                "UK-10",
                "UK-10.5",
                "UK-11",
                "UK-12",
                "UK-13",
                "UK-14",
                "W 9-11",
                "Unique"
              ];
              for (let j = 0; j < temp.length; j++) {
                for (let k = 0; k < sizes.length; k++) {
                  if (sizes[k].key == temp[j]) newArray.push(sizes[k]);
                }
              }
    
              facet.data = newArray;
            }
            else if (Array.isArray(facet.data)) {
              facet.data.sort((a, b) => a.label.localeCompare(b.label));
            }

            if (facet.key === "colors") {
              const facetItem = facet.data;
              facetItem?.forEach((item) => {
                let color=findHaxCode(item.key)
                  item.isSwatch = true;
                  item.isURLSwatch = color[1];
                  item.isVisualSwatch = true;
                  item.swatchValue =color[0];
                  item.data = {
                      value: item.key,
                      swatch: {
                          type: 'visual',
                          value: color[0]
                      }
                  }

              });
            }
          });
      }

      let attempts = 0;
      const maxAttempts = 5;
      const delay = 300; // delay between checks in milliseconds
      let expressPincodeMapping = null;

      while (attempts < maxAttempts) {
        expressPincodeMapping = window.expressPincodeMappings;
        // console.log("Wiz expressPincodeMapping", expressPincodeMapping);
        if (expressPincodeMapping) {
          break;  // Exit loop once attribute data is found
        }

        attempts++;
        if (attempts >= maxAttempts) {
          break;  // If max attempts are reached, return the payload as is
        }

        const start = new Date().getTime();
        let now = null;
        while ((now = new Date().getTime()) - start < delay) {
          // Wait for 'delay' milliseconds
        }
      }
      
      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.VIEW_RENDERED,
    function (data) {
      // console.log("Wiz VIEW_RENDERED", data);

      
      if (window.wizzyConfig?.common?.isOnCategoryPage) {
        let rawData = window.groupedCategories;
    
    
        if (rawData) {
          // Decode HTML entities
          rawData = rawData.replace(/&gt;/g, '>').replace(/&amp;/g, '&');
        
          const categoryGroups = rawData.split('||');
          let hasParentStructure = categoryGroups.some(group => group.includes('++') && group.includes('>'));
        
          const sidebar = document.createElement('div');
          sidebar.className = 'sidebar-categories';
        
          // const title = document.createElement('h4');
          // title.className = 'sidebar-title';
          // title.textContent = 'Categories';
          // sidebar.appendChild(title);
        
          const ul = document.createElement('ul');
          ul.className = 'category-list';
          ul.setAttribute('role', 'list');
        
          if (hasParentStructure) {
            categoryGroups.forEach(group => {
              const [parentHandleRaw, remainderRaw] = group.split('++');
              const [parentTitleRaw, childrenRaw] = remainderRaw.split('>');
        
              const parentHandle = parentHandleRaw.trim();
              const parentTitle = parentTitleRaw.trim();
              const childrenList = childrenRaw ? childrenRaw.split(',') : [];
        
              const li = document.createElement('li');
        
              const details = document.createElement('details');
        
              const summary = document.createElement('summary');
              summary.className = 'category-item';
        
              const a = document.createElement('a');
              a.className = 'category-titles';
              a.href = `/collections/${parentHandle}`;
              a.textContent = parentTitle;
        
              summary.appendChild(a);
        
              // Optional icons – replace with SVGs if needed
              summary.innerHTML += `
                <span class="icon icon-plus">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-plus" viewBox="0 0 10 10">
                <path fill="currentColor" fill-rule="evenodd" d="M1 4.51a.5.5 0 0 0 0 1h3.5l.01 3.5a.5.5 0 0 0 1-.01V5.5l3.5-.01a.5.5 0 0 0-.01-1H5.5L5.49.99a.5.5 0 0 0-1 .01v3.5l-3.5.01z" clip-rule="evenodd">
                </path>
                </svg>
                </span>
                <span class="icon icon-minus">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-minus" viewBox="0 0 10 2">
                <path fill="currentColor" fill-rule="evenodd" d="M.5 1C.5.7.7.5 1 .5h8a.5.5 0 1 1 0 1H1A.5.5 0 0 1 .5 1" clip-rule="evenodd">
                </path>
                </svg>
                </span>
              `;
        
              const subUl = document.createElement('ul');
              subUl.className = 'sub-category-list accordion__content rte';
        
              childrenList.forEach(child => {
                const [childHandleRaw, childTitleRaw] = child.split('--');
                const childHandle = childHandleRaw.trim();
                const childTitle = (childTitleRaw || '').trim();
        
                const subLi = document.createElement('li');
                const subA = document.createElement('a');
                subA.href = `/collections/${childHandle}`;
                subA.textContent = childTitle;
                subLi.appendChild(subA);
                subUl.appendChild(subLi);
              });
        
              details.appendChild(summary);
              details.appendChild(subUl);
              li.appendChild(details);
              ul.appendChild(li);
            });
          } else {
            const childrenList = rawData.split(',');
            childrenList.forEach(child => {
              const [childHandleRaw, childTitleRaw] = child.split('--');
              const childHandle = childHandleRaw.trim();
              const childTitle = (childTitleRaw || '').trim();
        
              const li = document.createElement('li');
              const a = document.createElement('a');
              a.href = `/collections/${childHandle}`;
              a.textContent = childTitle;
        
              li.appendChild(a);
              ul.appendChild(li);
            });
          }
        
          sidebar.appendChild(ul);
        
          const target = document.querySelector('.wizzy-facet-body.facet-body-product_value_tags_category_tags');
        
          if (target) {
            target.innerHTML = ''; // Clear existing content
            target.appendChild(sidebar); // Inject the new category structure
          }
        }
      }

      if (window.collectionName) {
        var collectionTitle = document.querySelector("h1.collection-hero__title");
        if (collectionTitle) {
          collectionTitle.innerHTML = `<span class="visually-hidden">Collection: </span>${window.collectionName}`;
        }
      }

      var productsCount = window.wizzyConfig?.pageStore?.searchedResponse?.total;
      if (productsCount) {
        var productCountElement = document.querySelector('#ProductCountDesktop');
        if (productCountElement) {
          productCountElement.innerHTML = `<span id="ProductCountDesktop">${productsCount} items<span>`
        }
      }

      gridFiltersToggleOnOverflow();
      
      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.PRODUCTS_CACHED_RESULTS_RENDERED,
    function (data) {

      document.body.classList.add('wizzy-search-results-rendered');

      if (window.collectionName) {
        var collectionTitle = document.querySelector("h1.collection-hero__title");
        if (collectionTitle) {
          collectionTitle.innerHTML = `<span class="visually-hidden">Collection: </span>${window.collectionName}`;
        }
      }

      var productsCount = window.wizzyConfig?.pageStore?.searchedResponse?.total;
      if (productsCount) {
        var productCountElement = document.querySelector('#ProductCountDesktop');
        if (productCountElement) {
          productCountElement.innerHTML = `<span id="ProductCountDesktop">${productsCount} items<span>`
        }
      }

      gridFiltersToggleOnOverflow();

      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
    function (data) {
      // console.log("Wizzy AFTER_PRODUCTS_TRANSFORMED", data);
      data.forEach((product) => {
        // console.log("Wizzy product id", product.id);
        // console.log("Wizzy product singleVarientGroupId", product.singleVarientGroupId);
        if (typeof product.attributes === "undefined") {
          product.attributes = [];
        }

        product.attributes.forEach((attribute) => {
          if (attribute.id === "product_technologies_images_custom") {
            product.techImage = attribute.values[0].value[0].split("||")[0];
          }
          if (attribute.id === "product_badge_judgeme") {
            product.jugdemeReview = attribute.values[0].value[0];
          }
          if (attribute.id === "product_value_tags_labels") {
            // product.valueLabel = attribute.values[0].value[0];
            const labelValue = attribute.values[0].value[0];
            // unless compare_at_price > price AND label == "New Arrivals"
           if (!(product.price > product.sellingPrice && labelValue === "New Arrivals")) {
              product.valueLabel = labelValue;
            }
          }
          if (attribute.id === "product_important_logo_custom") {
            console.log("importantLogo",attribute.id);
            product.importantLogo = attribute.values[0].value[0];
          }
          if (attribute.id === "product_store_codes") {
            codeValues = attribute.values[0].value[0];
            try {
              codeValues = JSON.parse(codeValues);
            } catch (e) {
              console.error("Wizzy Express Invalid store codes JSON", e);
              return;
            }

            var userPincode = sessionStorage.getItem("storage_pincode");
            if (userPincode && window.expressPincodeMappings) {
              var mappingEntry = window.expressPincodeMappings.find(
                (entry) => entry.pincode == userPincode
              );

              if (mappingEntry) {
                var storePriority = Object.keys(mappingEntry)
                  .filter((key) => key.startsWith("storeCode"))
                  .sort((a, b) => a.localeCompare(b))
                  .map((key) => mappingEntry[key])
                  .filter((code) => !!code);

                if (storePriority) {
                  for (let storeCode of storePriority) {
                    if (codeValues[storeCode] && codeValues[storeCode] > 0) {
                      product.expressDeliveryEligible = true;
                      break;
                    }
                  }
                }
              }
            }
          }
        });
        // console.log("attribute:-",product.attributes);
      });

      return data;
    },
    1
  );
};

function findHaxCode(key) {

  if (colorMap.has(key)) {
    return colorMap.get(key);
  } else {
    return [key, false];
  }
}

function gridFiltersToggleOnOverflow() {
  if (window.innerWidth > 768) {
    const filterBoxes = document.querySelectorAll(".wizzy-grid-filters-box");

    if (filterBoxes.length > 0) {
      filterBoxes.forEach((box) => {
        const filterList = box.querySelector(
          ".wizzy-facet-body .wizzy-facet-list"
        );
        const toggleBtn = box.querySelector(
          ".wizzy-facet-body .wizzy-toggle-btn"
        );
        const filterOptions = box.querySelector(".wizzy-facet-body");

        if (
          filterList &&
          toggleBtn &&
          filterOptions &&
          !toggleBtn.classList.contains("wizzy-click-event-attached")
        ) {
          const filterHeight = filterList.offsetHeight;
          const lineHeight = parseFloat(
            getComputedStyle(filterList).lineHeight
          );
          const maxVisibleLines = 2;
          const visibleLines = Math.floor(filterHeight / lineHeight) - 1;

          if (visibleLines > maxVisibleLines) {
            filterOptions.classList.add("collapsed");
            toggleBtn.classList.add("wizzy-click-event-attached");
            toggleBtn.style.display = "inline-block";
          } else {
            toggleBtn.style.display = "none";
          }

          toggleBtn.addEventListener("click", function () {
            if (filterOptions.classList.contains("collapsed")) {
              filterOptions.classList.remove("collapsed");
              filterOptions.classList.add("expanded");
              toggleBtn.innerText = "- Less";
            } else {
              filterOptions.classList.remove("expanded");
              filterOptions.classList.add("collapsed");
              toggleBtn.innerText = "+ More";
            }
            toggleBtn.classList.add("wizzy-click-event-attached");
          });
        }
      });
    }
  }
}
